import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import React from 'react';
import '../styles/components/Filter.scss';
import { useSearchParams } from 'react-router-dom';

const Filter = ({ filterdata, defaultChecked, setChecked, checked, setCheckedSub, checkedSub }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    // const handleCheckboxChange = (event, filterName) => {
    //     if (event.target.checked) {
    //         // Add the filter to the checked list
    //         setChecked((prev) => [...prev, filterName]);
    //     } else {
    //         // Remove the filter from the checked list
    //         setChecked((prev) => prev.filter((name) => name !== filterName));
    //     }
    // };
    const handleCheckboxChange = (event, filterName, filterLabel) => {
        if (event.target.checked) {
            // Add the filter to the checked list
            setChecked({ name: filterName, label: filterLabel });
        } else {
            // Remove the filter from the checked list
            setChecked();
        }
    };
    const handleCheckboxSubChange = (event, filterName, filterLabel) => {
        if (event.target.checked) {
            // Add the filter to the checked list
            setCheckedSub({ name: filterName, label: filterLabel });
        } else {
            // Remove the filter from the checked list
            setCheckedSub();
        }
    };

    // console.log(defaultChecked, checked);
    // console.log("filterdata", filterdata);


    const handleClearAll = () => {
        // Clear all filters, including defaultChecked
        setChecked(null);
        setCheckedSub(null);
        setSearchParams({});
    };
    // console.log("checked", checked);


    return (
        <div className="filter_header">
            <div className="filter_head">
                <Typography variant="h3">Filters</Typography>
                <Button onClick={handleClearAll}>Clear all</Button>
            </div>
            <div className="filter_list">
                <div className="filter_card" >
                    <Typography variant="h4">{filterdata[0]?.header}</Typography>
                    {filterdata[0]?.filters?.map((filter, idx) => (
                        <FormGroup key={idx}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name={filter?.name}
                                        checked={checked?.name === filter?.name}
                                        onChange={(event) => handleCheckboxChange(event, filter?.name, filter?.label)}
                                        sx={{
                                            color: '#E37B00',
                                            '&.Mui-checked': {
                                                color: '#E37B00',
                                            },
                                        }}
                                        disabled={checked?.name === filter?.name}
                                    />
                                }
                                label={filter.label}
                            />
                        </FormGroup>
                    ))}
                </div>
                {checked === null ? null :
                    <div className="filter_card" >
                        <Typography variant="h4">{filterdata[1]?.header}</Typography>
                        {filterdata[1]?.filters?.map((filter, idx) => (
                            <FormGroup key={idx}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name={filter?.name}
                                            checked={checkedSub?.name === filter?.name}
                                            onChange={(event) => handleCheckboxSubChange(event, filter?.name, filter?.label)}
                                            sx={{
                                                color: '#E37B00',
                                                '&.Mui-checked': {
                                                    color: '#E37B00',
                                                },
                                            }}
                                            disabled={checkedSub?.name === filter?.name}
                                        />
                                    }
                                    label={filter.label}
                                />
                            </FormGroup>
                        ))}
                    </div>}
            </div>
        </div>
    );
};

export default Filter;
